// extracted by mini-css-extract-plugin
export var item = "search-bar-module--item--CwJ4j";
export var items = "search-bar-module--items--dNhSb";
export var leftArrow = "search-bar-module--left-arrow--gExVY";
export var navigation = "search-bar-module--navigation--2bQfO";
export var rightArrow = "search-bar-module--right-arrow--s6qD6";
export var searchBar = "search-bar-module--search-bar---DXn1";
export var selectedItem = "search-bar-module--selected-item--w7TZn";